import { requestHelpers } from '../../helpers';

const actions = {
    GET_PERSON_ADDRESSES: "GET_PERSON_ADDRESSES",
    SET_PERSON_ADDRESSES: "SET_PERSON_ADDRESSES",
    ADD_PERSON_ADDRESS: "ADD_PERSON_ADDRESS",
    POST_PERSON_ADDRESS: "POST_PERSON_ADDRESS",
    POST_PERSON_BILLING_ADDRESS: "POST_PERSON_BILLING_ADDRESS",
    SET_PERSON_BILLING_ADDRESS: "SET_PERSON_BILLING_ADDRESS",
    RESET_ADDRESS: 'RESET_ADDRESS',
};

function getPersonAddresses( personId ) {
    //console.log('********ACTION GET ADDRESSES', personId);
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_PERSON_ADDRESSES,
        } );

        requestHelpers
            .authenticatedGetRequest( `/people/${ personId }/addresses` )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_PERSON_ADDRESSES,
                    addresses: response.data,
                } )
            } );
    };
}

function addPersonAddress( personId, address ) {
    //console.log('**************ACTION POST ADDRESSES', personId);
    return ( dispatch ) => {
        dispatch( {
            type: actions.POST_PERSON_ADDRESS,
        } );

        requestHelpers
            .authenticatedPostRequest( `/people/${ personId }/addresses`, address )
            .then( ( response ) => {

                dispatch( {
                    type: actions.ADD_PERSON_ADDRESS,
                    address: response.data,
                } );
                dispatch( {
                    type: actions.SET_PERSON_BILLING_ADDRESS,
                    addressId: response.data.id,
                } );
            } );
    };
}

function setPersonBillingAddress( addressId ) {
    //console.log('***********ACTION SET BILLING ADDRESSES', addressId);
    return ( dispatch ) => {
        dispatch({
            type: actions.SET_PERSON_BILLING_ADDRESS,
            addressId,
        });
    };
}

function postPersonBillingAddress( personId, addressId ) {
    //console.log('*************ACTION POST BILLING ADDRESSES', personId, addressId);
    return ( dispatch ) => {
        dispatch( {
            type: actions.POST_PERSON_BILLING_ADDRESS,
            addressId,
        } );

        requestHelpers
            .authenticatedPostRequest( `/people/${ personId }/addresses/${ addressId }/billing` )
            .then( ( response ) => {} )
    }
}

function resetAddress( ) {
    return ( dispatch ) => {
        dispatch({
            type: actions.RESET_ADDRESS,
        });
    };
}

module.exports = {
    actions,
    getPersonAddresses,
    addPersonAddress,
    setPersonBillingAddress,
    postPersonBillingAddress,
    resetAddress
};



// WEBPACK FOOTER //
// src/client/actions/transactions/address.js